import { useEffect, useState } from "react";
import { toast } from "sonner";
import CommercialSessionLobby from "../components/CommercialSessionLobby";
import { createCommercialSession } from "../lib/api";
import {
  getMostRecentCommercialConnection,
  removeCommercialConnection,
  saveCommercialConnection,
} from "../lib/commercialSessionStorage";
import PageWrapper from "./PageWrapper";

export default function CreateSessionView() {
  const [pseudonym, setPseudonym] = useState("");
  const [connection, setConnection] = useState(null);
  const [restored, setRestored] = useState(false);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    setConnection(getMostRecentCommercialConnection());
    setRestored(true);
  }, []);

  const createSession = async (event) => {
    event.preventDefault();
    const cleaned = pseudonym.trim();
    if (!cleaned) {
      toast.error("Choisissez un pseudonyme pour cette partie");
      return;
    }
    setCreating(true);
    try {
      const created = await createCommercialSession({ pseudonym: cleaned });
      saveCommercialConnection(created);
      setConnection(created);
      toast.success("Votre partie privée est créée");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Impossible de créer la partie");
    } finally {
      setCreating(false);
    }
  };

  const createAnother = () => {
    if (connection?.sessionId) removeCommercialConnection(connection.sessionId);
    setConnection(null);
    setPseudonym("");
  };

  if (!restored) return <div className="loading-screen"><span className="loading-dot" /></div>;
  if (connection) return <CommercialSessionLobby connection={connection} onCreateAnother={createAnother} />;

  return (
    <PageWrapper>
      <div className="commercial-entry" data-testid="create-commercial-session">
        <p className="page-eyebrow">Dualflip · Partie privée</p>
        <h1 className="page-title">Créer une partie</h1>
        <p className="commercial-intro">
          Créez un lobby pour deux. Votre pseudonyme appartient seulement à cette session.
        </p>
        <form className="commercial-entry-card" onSubmit={createSession}>
          <label htmlFor="commercial-pseudonym">Votre pseudonyme</label>
          <input
            id="commercial-pseudonym"
            data-testid="commercial-create-pseudonym"
            value={pseudonym}
            onChange={(event) => setPseudonym(event.target.value)}
            maxLength={48}
            placeholder="Ex. Joris"
            autoComplete="nickname"
          />
          <button className="btn-primary" type="submit" disabled={creating} data-testid="commercial-create-submit">
            {creating ? "Création…" : "Créer ma partie"}
          </button>
        </form>
      </div>
    </PageWrapper>
  );
}
